var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-markup"},[_c('prism',{attrs:{"language":_vm.language}},[_vm._t("default")],2),_c('div',{staticClass:"v-markup__copy"},[_c('v-icon',{on:{"click":_vm.copyMarkup}},[_vm._v("content_copy")]),_c('v-slide-x-transition',[(_vm.copied)?_c('span',{staticClass:"v-markup__copied"},[_vm._v("Copied")]):_vm._e()])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }